import React from 'react';
import { Link } from 'react-router-dom';
import { Header } from './Header';

interface LayoutProps {
  children: React.ReactNode;
  // Full-bleed pages (Home) lay out their own bands and containers
  fullBleed?: boolean;
}

export const Layout: React.FC<LayoutProps> = ({
  children,
  fullBleed = false,
}) => {
  return (
    <div className="h-screen flex flex-col bg-canvas text-fg">
      <Header />
      <main id="main-content" className="flex-1 overflow-y-auto flex flex-col">
        <div className="flex-1">
          {fullBleed ? children : (
            <div className="mx-auto w-full max-w-7xl px-4 py-6 sm:px-6 sm:py-8">
              {children}
            </div>
          )}
        </div>
        <footer className="border-t border-line">
          <div className="mx-auto flex max-w-7xl flex-wrap items-center gap-x-6 gap-y-2 px-4 py-5 text-sm text-muted sm:px-6">
            <span>© {new Date().getFullYear()} ComponentScale</span>
            <Link to="/privacy-policy" className="hover:text-fg transition-colors">Privacy Policy</Link>
            <Link to="/amazon-disclosure" className="hover:text-fg transition-colors">Amazon Disclosure</Link>
            <span className="font-mono text-xs sm:ml-auto">Dimensions: H × W × D, external</span>
          </div>
        </footer>
      </main>
    </div>
  );
};
